<template>
    <CompassTable :hasExpandableRows="hasExpandableRows" class="objectives-listing-table__table">
        <CompassTableHead isFixed @sort="handleSortListingTable">
            <CompassTableHeadCell
                v-for="column in visibleColumns"
                :id="column.code"
                :key="`objectives-listing-table__table-column-${column.code}`"
                :fixed="column.fixed"
                :minWidth="column.width"
                :sortable="column.sortable"
            >
                {{ column.label }}
            </CompassTableHeadCell>

            <CompassTableHeadCell id="actionColumn" fixed="right" fitContent />
        </CompassTableHead>

        <CompassTableBody>
            <template v-if="isEmptyList" #empty>
                <ObjectivesListingTableEmpty
                    :hasActiveFilters="hasActiveFilters"
                    :buttonConfig="createObjectiveButton"
                    @reset-filters="handleResetFilters"
                />
            </template>
            <template v-else #default>
                <template
                    v-for="row in rows"
                    :key="`objectives-listing-table__table-row-${row.id}`"
                >
                    <ObjectivesListingTableRow
                        :row="row"
                        :columns="visibleColumns"
                        @update:subrowVisibility="
                            (subrowVisibility) => {
                                row.subrowsVisible = subrowVisibility;
                            }
                        "
                    />

                    <ObjectivesListingTableSubrow
                        v-if="row.subrows.length > 0"
                        :key="`objectives-listing-table__table-row-${row.id}-subrow`"
                        :rowId="row.id"
                        :subrows="row.subrows"
                        :subrowColumns="row.subrowColumns"
                        :visible="row.subrowsVisible"
                    />
                </template>
            </template>
        </CompassTableBody>
    </CompassTable>
</template>

<script>
import ObjectivesListingTableEmpty from 'vcomponents/objectives/listing/ObjectivesListingTableEmpty.vue';
import ObjectivesListingTableRow from 'vcomponents/objectives/listing/ObjectivesListingTableRow.vue';
import ObjectivesListingTableSubrow from 'vcomponents/objectives/listing/ObjectivesListingTableSubrow.vue';

export default {
    components: {
        ObjectivesListingTableEmpty,
        ObjectivesListingTableRow,
        ObjectivesListingTableSubrow,
    },
    props: {
        columns: {
            type: Array,
            required: true,
        },
        rows: {
            type: Array,
            required: true,
        },
        createObjectiveButton: {
            type: Object,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        hasActiveFilters: {
            type: Boolean,
            default: false,
        },
        hasExpandableRows: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isEmptyList() {
            return !this.loading && this.rows.length === 0;
        },
        visibleColumns() {
            return this.columns
                .filter((column) => column.isVisible)
                .sort((columnA, columnB) => {
                    if (columnA.order < columnB.order) {
                        return -1;
                    } else if (columnA.order > columnB.order) {
                        return 1;
                    } else {
                        return 0;
                    }
                });
        },
    },
    methods: {
        handleResetFilters() {
            this.$emit('resetFilters');
        },
        handleSortListingTable(newParams) {
            this.$emit('sort', {
                direction: newParams.direction,
                order: newParams.orderBy,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.objectives-listing-table__table {
    :deep() {
        .objectives-listing-table__table-progress-bar {
            width: 100%;
            .compass-tooltip,
            .compass-tooltip__element {
                display: block;
            }
        }
    }
}
</style>
